// extracted by mini-css-extract-plugin
export default {"accountCredentials":"account-credentials-module__accountCredentials___qS8-2","error":"account-credentials-module__error___06p+W"};